import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { Injectable } from '@angular/core';

@Injectable()
export class FeedbackResultService extends RestfulService<Models.FeedbackResponse> {
  constructor(public restService: RestService) {
    super(Models.FeedbackResponse);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('feedback-responses');
  }
}
